import React from 'react'
import '../../common/styles/PrivacyPolicy.css'
import { Card, Typography } from 'antd'
import { useThemeColors } from '../../common/ThemeContext'

const { Title, Text } = Typography

const font = 'Times New Roman, Times, serif'

function PrivacyPolicy() {
	const tc = useThemeColors()
	const linkStyle: React.CSSProperties = { fontFamily: font, color: tc.primary }

	return (
		<>
			<Card
				style={{
					margin: '20px',
					textAlign: 'center',
					backgroundColor: tc.subBg,
					borderColor: tc.border,
				}}
			>
				<Title
					level={2}
					id='privacy-policy-title'
					style={{
						color: tc.primary,
						fontFamily: font,
						marginBottom: 0,
					}}
				>
					Privacy Policy for EDC AMS Mobile App (PowerPlantC7)
				</Title>
			</Card>
			<Card
				style={{
					margin: '20px',
					backgroundColor: tc.bg,
					borderColor: tc.border,
					fontFamily: font,
				}}
			>
				<div className='privacy-policy' style={{ color: tc.text, fontFamily: font }}>
					<Title level={3} style={{ fontFamily: font, color: tc.text }}>
						Privacy Policy
					</Title>
					<Text style={{ fontFamily: font, color: tc.text }}>
						<strong>Last updated:</strong> November 28, 2024
					</Text>

					<section>
						<Text style={{ fontFamily: font, color: tc.text }}>
							This Privacy Policy explains how Primersoft ("we", "our", or "us")
							collects, uses, and protects your information when you use the EDC AMS
							Mobile App (PowerPlantC7) ("the Application").
						</Text>
					</section>

					<section>
						<Title level={4} style={{ fontFamily: font, color: tc.text }}>
							1. Information We Collect
						</Title>
						<ul style={{ fontFamily: font, color: tc.text }}>
							<li>
								<strong>Authentication Data:</strong> Phone numbers and OTP codes
								for secure login.
							</li>
							<li>
								<strong>Attendance Data:</strong> Check-in and check-out
								information, including timestamps and locations.
							</li>
							<li>
								<strong>Profile Data:</strong> Staff details stored and managed
								through our web portal.
							</li>
							<li>
								<strong>Location Data:</strong> Device location to confirm
								attendance actions within the defined radius (350m).
							</li>
						</ul>
					</section>

					<section>
						<Title level={4} style={{ fontFamily: font, color: tc.text }}>
							2. How We Use Your Information
						</Title>
						<Text style={{ fontFamily: font, color: tc.text }}>
							We use your data to provide, maintain, and improve the Application. This
							includes:
						</Text>
						<ul style={{ fontFamily: font, color: tc.text }}>
							<li>Authenticating user access to the app.</li>
							<li>
								Ensuring functionality of check-in, check-out, and attendance
								refresh features.
							</li>
							<li>Generating attendance reports for admin purposes.</li>
						</ul>
					</section>

					<section>
						<Title level={4} style={{ fontFamily: font, color: tc.text }}>
							3. Data Storage and Security
						</Title>
						<Text style={{ fontFamily: font, color: tc.text }}>
							Your data is securely stored using encryption and industry best
							practices. It is only accessible by authorized personnel for operational
							purposes.
						</Text>
					</section>

					<section>
						<Title level={4} style={{ fontFamily: font, color: tc.text }}>
							4. Your Rights
						</Title>
						<Text style={{ fontFamily: font, color: tc.text }}>
							You have the right to access, update, or request deletion of your
							personal data. To exercise these rights, contact us at{' '}
							<a href='mailto:chendachhean@gmail.com' style={linkStyle}>
								chendachhean@gmail.com
							</a>
							.
						</Text>
					</section>

					<section>
						<Title level={4} style={{ fontFamily: font, color: tc.text }}>
							5. Data Sharing
						</Title>
						<Text style={{ fontFamily: font, color: tc.text }}>
							We do not share your information with third parties except as required
							by law or with your explicit consent.
						</Text>
					</section>

					<section>
						<Title level={4} style={{ fontFamily: font, color: tc.text }}>
							6. Updates to This Privacy Policy
						</Title>
						<Text style={{ fontFamily: font, color: tc.text }}>
							We may update this policy from time to time. Significant changes will be
							notified to users through the app.
						</Text>
					</section>

					<section>
						<Title level={4} style={{ fontFamily: font, color: tc.text }}>
							7. Contact Information
						</Title>
						<Text style={{ fontFamily: font, color: tc.text }}>
							For questions about this Privacy Policy, contact us at:
							<br />
							<a href='mailto:chendachhean@gmail.com' style={linkStyle}>
								chendachhean@gmail.com
							</a>
						</Text>
					</section>
				</div>
			</Card>
		</>
	)
}

export default PrivacyPolicy
